import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer id="contact" className="footer-section">
      <div className="booking-info">
        <span>BOOKING: </span>
        <a href="mailto:placeholder@example.com">placeholder@example.com</a>
      </div>
      <div className="social-links">
        <a href="#" target="_blank" rel="noopener noreferrer">Instagram</a>
        <a href="#" target="_blank" rel="noopener noreferrer">Spotify</a>
        <a href="#" target="_blank" rel="noopener noreferrer">SoundCloud</a>
      </div>
    </footer>
  );
};

export default Footer;
